import { useTranslation as useI18nTranslation } from '@simplywallst/hooks/useTranslation';
import type * as WebTranslations from '@assets/locales/en/web.json';

/**
 * Displays text translated using the current locale language.
 *
 * @example
 * const t = useTranslation()
 *
 * // Will return 'Dashboard' when language is `en` and 'Cuadro de mandos' when language is `es`
 * t('app.topbar.nav.dashboard')
 */
export const useTranslation = () => {
  const i18nTranslate = useI18nTranslation<
    'web',
    keyof typeof WebTranslations
  >();

  // Cast the translate function to enforce typing + autocomplete on the web translation keys.
  return i18nTranslate.t as (
    key: keyof typeof WebTranslations,
    // Options can include a `count` (used for pluralisation) and any other arbitrary key/value pair
    // used for interpolating values.
    options?: { count?: number } & Record<string, string>
  ) => string;
};
